import {
  HttpInterceptorFn,
  provideHttpClient,
  withInterceptors,
  withXhr,
} from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  apiErrorInterceptor,
  authInterceptor,
  csrfInterceptor,
  dealerIdInterceptor,
  licensePlateInterceptor,
  localeInterceptor,
  withCredentialsInterceptor,
} from './interceptors';
import { DUTCH_LOCALE_PROVIDER } from './providers/dutch-locale';
import {
  resolveLanguageCid,
  TranslationLoaderService,
} from './services/translation-loader.service';

// The HTTP interceptor chain for the standalone app (main.ts).
export const CORE_INTERCEPTORS: readonly HttpInterceptorFn[] = [
  csrfInterceptor,
  withCredentialsInterceptor,
  localeInterceptor,
  dealerIdInterceptor,
  licensePlateInterceptor,
  authInterceptor,
  apiErrorInterceptor,
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptors([...CORE_INTERCEPTORS])),
    DUTCH_LOCALE_PROVIDER,
    // Fired in parallel with App's existing dealer-config gate (same backend, same piston
    // loader), NOT blocking bootstrap: blocking serialises this ahead of the dealer-config
    // fetch and doubles time-to-content on a slow backend. App holds its shell loader on
    // TranslationLoaderService.ready instead, so no screen (gate included) paints raw cids
    // while the overlay is in flight. A 5xx runs the shared retry modal; load() never rejects.
    provideAppInitializer((): void => {
      inject(TranslationLoaderService)
        .load(resolveLanguageCid(globalThis.location.search))
        .subscribe();
    }),
  ],
};
